<template>
  <div class="app-containers">
    <div style="width:76%;float:left;margin-bottom:10px">
      <search @success="getList">
        <el-form style="margin:11px 0px 0px -26px;width:430px" label-width="120px" class="styleForm">
          <el-form-item label="存货名称 ：">          
            <el-input v-model="listQuery.name" placeholder="请输入名称" style="width: 200px;" size="mini" />
          </el-form-item>
          <el-form-item label="存货类型 ："> 
            <selectInventoryType v-model:type="listQuery.type"></selectInventoryType>
          </el-form-item>
        </el-form>
      </search>
    </div>
    <div style="width:20%;text-align:right;float:right">
      <qzf-button jz="true" plain @success="inventoryStockIn">手动入库</qzf-button>
      <qzf-button jz="true" plain @success="inventoryStockOut">手动出库</qzf-button>
      <el-dropdown size="mini" style="margin-left:10px">
        <el-button size="mini" type="primary">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="b">
              <span @click="exportInventory">导出</span>
            </el-dropdown-item>
            <el-dropdown-item command="c">
              <span @click="singleDayin">打印</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <el-table stripe border size="mini" :data="list" style="width: 100%" show-summary :tree-props="{children: 'children', hasChildren: 'hasChildren'}" row-key="id" default-expand-all :height="contentStyleObj" v-loading="loading">
      <el-table-column fixed prop="inventoryName" label="名称" min-width="180">
        <template #default="scope">
          <span style="word-wrap: break-word">{{scope.row.inventoryName}}</span>
        </template>
      </el-table-column>

      <el-table-column fixed prop="inventorySpec" label="型号" min-width="180">
        <template #default="scope">
          <span>{{scope.row.inventorySpec}}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="存货类型" min-width="100">
        <template #default="scope">
          <span>{{$inventoryTypeFilter(scope.row.inventoryType)}}</span>
        </template>
      </el-table-column>

      <el-table-column label="期末库存" header-align='center'>
        <el-table-column prop="endCount" label="数量" align="center" min-width="120"></el-table-column>
        <el-table-column label="平均单价" prop="averagePrice" align="center" min-width="120">
          <template #default="scope">
            <span v-if="scope.row.endCount">{{ (scope.row.endAmount/scope.row.endCount).toFixed(2) }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column prop="endAmount" label="金额" align="center" min-width="120">
        </el-table-column>
      </el-table-column>

      <el-table-column label="本期入库" header-align='center'>
        <el-table-column prop="inCount" label="数量" align="center" min-width="120">
        </el-table-column>
        <el-table-column label="平均单价" prop="averagePrice" align="center" min-width="120">
          <template #default="scope">
            <span v-if="scope.row.inCount">{{ (scope.row.inAmount/scope.row.inCount).toFixed(2) }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column prop="inAmount" label="金额" align="center" min-width="120">
        </el-table-column>
      </el-table-column>
      <el-table-column label="暂估入库" header-align='center'>
        <el-table-column prop="estimateCount" label="数量" align="center" min-width="120">
        </el-table-column>
        <el-table-column label="平均单价" prop="averagePrice" align="center" min-width="120">
          <template #default="scope">
            <span v-if="scope.row.estimateCount ">{{ (scope.row.estimateAmount/scope.row.estimateCount).toFixed(2) }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column prop="estimateAmount" label="金额" align="center" min-width="120">
        </el-table-column>
      </el-table-column>
      <el-table-column label="本期出库" header-align='center'>
        <el-table-column prop="outCount" label="数量" align="center" min-width="120">
        </el-table-column>
        <el-table-column label="平均单价" prop="averagePrice" align="center" min-width="120">
          <template #default="scope">
            <span v-if="scope.row.outCount">{{ (scope.row.outAmount/scope.row.outCount).toFixed(2) }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column prop="outAmount" label="金额" align="center" min-width="120">
        </el-table-column>
      </el-table-column>

      <el-table-column label="期初库存" header-align='center'>
        <el-table-column prop="beginCount" label="数量" align="center" min-width="120">
        </el-table-column>
        <el-table-column label="平均单价" prop="averagePrice" align="center" min-width="120">
          <template #default="scope">
            <span v-if="scope.row.beginCount ">{{ (scope.row.beginAmount/scope.row.beginCount).toFixed(2) }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column prop="beginAmount" label="金额" align="center" min-width="120">
        </el-table-column>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <qzf-pagination v-show="total>0" :total="total" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
    </div>
    <inventoryStock @success="getList()" ref="inventoryStockIn" name="手动入库"></inventoryStock>
    <inventoryStock @success="getList()" ref="inventoryStockOut" name="手动出库"></inventoryStock>
  </div>
</template>

<script>
import { inventoryPeriodList } from '@/api/inventory'
import inventoryStock from "./inventoryStock.vue"
import selectInventoryType from "./selectInventoryType.vue"
export default {
  name:'inventoryPeriod',
  components:{
    inventoryStock,
    selectInventoryType
  },
  data() {
    return {
      list:[],
      listQuery: {
        subjectCode: '',
        name: '',
        change: 0,
        page: 1,
        limit: 20,
      },
      total:0,
      loading:false,
    }
  },
  created(){
    this.getList()
    this.contentStyleObj= this.$getHeight(280)
    this.initBus()
  },
  methods:{
    initBus(){
      this.$bus.off("inventoryPeriodUpdate")
      this.$bus.on("inventoryPeriodUpdate", (val) => {
        this.getList()
      });
    },
    getList(){
        this.loading = true
      inventoryPeriodList(this.listQuery).then(res=>{
        this.loading = false
        if(res.data.data.list){
          this.list = res.data.data.list
          this.total = res.data.data.total
        }else{
          this.list = []
        }
        
      })
    },
    inventoryStockIn(){
      this.$refs.inventoryStockIn.init()
    },
    inventoryStockOut(){
      this.$refs.inventoryStockOut.init()
    },
  }
}
</script>

<style>

</style>

<style scoped lang="scss">
.el-table {
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.el-select{
  margin-left:0px
}
.app-containers {
  padding: 10px 20px;
  width: 100%;
  margin: 0 auto 0px auto;
  min-height: calc(100vh - 180px);
  border:1px solid #e6e6e6;
  position: relative;
}
</style>